import React from 'react';
import { OFFER_ANCHOR } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = OFFER_ANCHOR,
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-2 rounded-md border-b-4 border-black/25 bg-golf-lime px-4 py-3 text-center font-head text-[15px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-lg shadow-golf-green/25 transition-[background-color,transform,border-color] duration-150 ease-out hover:bg-[#8AC935] active:translate-y-1 active:border-b-0 sm:px-6 sm:text-lg ${className}`} data-id="element-32" data-mp="2kzzkh2eklwyl">
      {children}
    </a>;
}